import React, { Fragment, useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import CreaSistemaCalidad from "../Modals/crear/CreaSistemaCalidad";
import Cookies from "universal-cookie";
import { FaCheck, FaClock, FaTimes, FaTrash } from "react-icons/fa";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

function InfoSistemaCalidad(props) {
  const { id } = useParams();
  const cookies = new Cookies();

  const tipoUsuario = Number(cookies.get("tipo_Usuario"));
  const idUsuario = cookies.get("id");

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [processingId, setProcessingId] = useState(null);

  // Tipo 1: puede aprobar o rechazar
  const puedeAprobar = tipoUsuario === 1;

  // Tipo 2: puede crear y eliminar
  const puedeGestionar = tipoUsuario === 2;

  // Tipo 1 y 2 tienen acciones
  const tieneAcciones = puedeAprobar || puedeGestionar;

  /**
   * Obtener sistemas de calidad
   */
  const getData = useCallback(async () => {
    if (!props.idSolicitud) return;

    setLoading(true);

    try {
      const response = await axios.get(
        `${API_URL}/ObtenerSistemaCalidadPorSolicitudId`,
        {
          auth: AUTH,
          params: {
            SolicitudId: props.idSolicitud,
          },
        },
      );

      setList(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error(
        "Error al obtener información del sistema de calidad:",
        error,
      );

      setList([]);
    } finally {
      setLoading(false);
    }
  }, [props.idSolicitud]);

  /**
   * Eliminar sistema de calidad
   * Solo usuario tipo 2
   */
  const handleDelete = useCallback(
    async (itemId) => {
      const confirmar = window.confirm(
        "¿Está seguro de que desea eliminar este registro?",
      );

      if (!confirmar) return;

      try {
        setProcessingId(itemId);

        await axios.delete(`${API_URL}/eliminarSistemaCalidadPorId`, {
          auth: AUTH,
          params: {
            Id: itemId,
          },
          data: {
            TipoAccion: "Eliminación de registro en sistema de calidad",
            IdUsuario: idUsuario,
          },
        });

        // Actualizar la lista local
        setList((prev) => prev.filter((item) => item.id !== itemId));

        alert("Registro eliminado correctamente.");
      } catch (error) {
        console.error("Error al eliminar el sistema de calidad:", error);

        alert(
          "No fue posible eliminar el registro. Por favor, intente nuevamente.",
        );
      } finally {
        setProcessingId(null);
      }
    },
    [idUsuario],
  );

  /**
   * Aprobar o rechazar sistema de calidad
   *
   * aprobacion = true  -> Aprobar
   * aprobacion = false -> Rechazar
   */
  const handleAprobacion = useCallback(async (sistemaCalidadId, aprobacion) => {
    const accion = aprobacion ? "aprobar" : "rechazar";

    const confirmar = window.confirm(
      `¿Está seguro de que desea ${accion} este sistema de calidad?`,
    );

    if (!confirmar) return;

    try {
      setProcessingId(sistemaCalidadId);

      await axios.put(
        `${API_URL}/ActualizaEstadoSistemaCalidad/${sistemaCalidadId}/${aprobacion}`,
        {},
        {
          auth: AUTH,
        },
      );

      // Actualizar estado local
      setList((prev) =>
        prev.map((item) =>
          item.id === sistemaCalidadId
            ? {
                ...item,
                aprobada: aprobacion,
                aprobacionRevisada: true,
              }
            : item,
        ),
      );

      alert(
        aprobacion
          ? "Sistema de calidad aprobado correctamente."
          : "Sistema de calidad rechazado correctamente.",
      );
    } catch (error) {
      console.error(`Error al ${accion} el sistema de calidad:`, error);

      alert(
        `No fue posible ${accion} el sistema de calidad. Por favor, intente nuevamente.`,
      );
    } finally {
      setProcessingId(null);
    }
  }, []);

  /**
   * Cargar información inicialmente
   */
  useEffect(() => {
    getData();
  }, [getData]);

  /**
   * Renderizar estado
   */
  const renderEstado = (item) => {
    if (item.aprobacionRevisada === false) {
      return (
        <span className="badge badge-warning">
          <FaClock className="mr-1" />
          Pendiente de revisión
        </span>
      );
    }

    if (item.aprobacionRevisada === true && item.aprobada === true) {
      return (
        <span className="badge badge-success">
          <FaCheck className="mr-1" />
          Aprobado
        </span>
      );
    }

    if (item.aprobacionRevisada === true && item.aprobada === false) {
      return (
        <span className="badge badge-danger">
          <FaTimes className="mr-1" />
          Rechazado
        </span>
      );
    }

    return <span className="badge badge-secondary">Estado no definido</span>;
  };

  /**
   * Botones aprobar / rechazar
   */
  const renderAccionesAprobacion = (item) => {
    const isProcessing = processingId === item.id;

    return (
      <div className="d-flex justify-content-center">
        <button
          type="button"
          className="btn btn-success btn-sm mr-2"
          title="Aprobar"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, true)}
        >
          <FaCheck className="mr-1" />

          {isProcessing ? "Procesando..." : "Aprobar"}
        </button>

        <button
          type="button"
          className="btn btn-danger btn-sm"
          title="Rechazar"
          disabled={isProcessing}
          onClick={() => handleAprobacion(item.id, false)}
        >
          <FaTimes className="mr-1" />

          {isProcessing ? "Procesando..." : "Rechazar"}
        </button>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información Sistema Calidad
              </h6>
            </div>

            <div className="card-body">
              {/* SOLO TIPO 2 PUEDE CREAR */}
              {puedeGestionar && (
                <div className="mb-4">
                  <CreaSistemaCalidad idSolicitud={id} onCreated={getData} />
                </div>
              )}

              <div className="table-responsive">
                <table
                  className="table table-bordered table-hover"
                  id="dataTable"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Implementado</th>
                      <th>Especifique</th>
                      <th>Auditorias Internas</th>
                      <th>Especificación Auditorias Internas</th>
                      <th>Documento</th>
                      <th>Estado</th>

                      {tieneAcciones && <th>Acciones</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td
                          colSpan={tieneAcciones ? 8 : 7}
                          className="text-center"
                        >
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only">Cargando...</span>
                          </div>

                          <div className="mt-2">
                            Cargando sistemas de calidad...
                          </div>
                        </td>
                      </tr>
                    ) : list.length === 0 ? (
                      <tr>
                        <td
                          colSpan={tieneAcciones ? 8 : 7}
                          className="text-center text-muted"
                        >
                          No existen registros de sistema de calidad.
                        </td>
                      </tr>
                    ) : (
                      list.map((item) => {
                        const isProcessing = processingId === item.id;

                        return (
                          <tr key={item.id}>
                            {/* ID */}
                            <td>{item.id}</td>

                            {/* IMPLEMENTADO */}
                            <td>{item.implementado || "Sin información"}</td>

                            {/* ESPECIFIQUE */}
                            <td>{item.especifique || "Sin información"}</td>

                            {/* AUDITORIAS INTERNAS */}
                            <td>
                              {item.auditoriasInternas || "Sin información"}
                            </td>

                            {/* ESPECIFICACIÓN AUDITORIAS */}
                            <td>
                              {item.especificacionAuditoriasInternas ||
                                "Sin información"}
                            </td>

                            {/* DOCUMENTO */}
                            <td>
                              {item.archivo ? (
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() =>
                                    descargarDocumento(item.archivo)
                                  }
                                >
                                  Descargar
                                </button>
                              ) : (
                                <span className="text-muted">No adjunto</span>
                              )}
                            </td>

                            {/* ESTADO */}
                            <td>{renderEstado(item)}</td>

                            {/* ACCIONES */}
                            {tieneAcciones && (
                              <td className="text-center">
                                {/* TIPO 1:
                                    APROBAR / RECHAZAR */}
                                {puedeAprobar && renderAccionesAprobacion(item)}

                                {/* TIPO 2:
                                    ELIMINAR */}
                                {puedeGestionar && (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm"
                                    title="Eliminar"
                                    disabled={isProcessing}
                                    onClick={() => handleDelete(item.id)}
                                  >
                                    <FaTrash className="mr-1" />

                                    {isProcessing
                                      ? "Eliminando..."
                                      : "Eliminar"}
                                  </button>
                                )}
                              </td>
                            )}
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default InfoSistemaCalidad;
